// components/layout/PersistentMainLayout.tsx
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { useAuth } from '../auth/hooks/useAuth';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import ProfileModal from '../modals/profile-modals/ProfileModal';
import { useModalContext } from '../../contexts/ModalContext';
import { useAuth0 } from '@auth0/auth0-react';
import { AUTH0_CONFIG } from "../../config/api.config";
import '../../../scss/Layout.scss';


const PersistentMainLayout = () => {

    const { user } = useAuth();
    const { logout } = useAuth0();
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const modalContext = useModalContext();

    const handleLogout = async () => {
        try {
            localStorage.clear();
            sessionStorage.clear();
            await logout({
                logoutParams: {
                    returnTo: window.location.origin + '/login'
                }
            });
        } catch (err) {
            console.error('Logout error:', err);
            window.location.href = '/login';
        }
    };

    const handlePasswordReset = () => {
        window.location.href = `https://${AUTH0_CONFIG.domain}/u/reset-password?client_id=${AUTH0_CONFIG.clientId}`;
    };

    if (!user) return null;

    const isNonAdmin = !user.role?.includes('admin');

    return (
        <div className="app-container vh-100 d-flex flex-column overflow-hidden">
            <Navbar
                user={user}
                onShowProfile={() => modalContext.setShowProfileModal(true)}
                onPasswordReset={handlePasswordReset}
                onLogout={handleLogout}
            />

            {isNonAdmin ? (
                // Simple full-width layout for non-admin users
                <div className="flex-grow-1 overflow-auto w-100">
                    <Container fluid className="p-4">
                        <Outlet />
                    </Container>
                </div>
            ) : (
                // Original layout with sidebar for admin users
                <div className="content-wrapper flex-grow-1 d-flex overflow-hidden">
                    <div className={`sidebar-container ${isSidebarCollapsed ? 'collapsed' : 'expanded'}`}>
                        <Sidebar
                            isCollapsed={isSidebarCollapsed}
                            onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                            userRole={user.role ?? 'user'}
                        />
                    </div>
                    <main className={`main-content flex-grow-1 overflow-auto ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
                        <Container fluid className="p-4">
                            <Outlet />
                        </Container>
                    </main>
                </div>
            )}

            <ProfileModal
                show={modalContext.showProfileModal}
                onHide={() => modalContext.setShowProfileModal(false)}
                profileData={modalContext.profileData}
                onUpdate={modalContext.handleProfileUpdate}
                onChange={modalContext.handleDataChange}
                error={modalContext.error}
                success={modalContext.success}
                isLoading={modalContext.isLoading}
            />
        </div>
    );
};

export default PersistentMainLayout;